<template>
	<div class="omapi-monsterleads__table">
		<div class="tablenav top">
			<div class="omapi-monsterleads__actions">
				<div class="omapi-monsterleads__filters">
					<core-search-button @updated="updateSearch"></core-search-button>
					<select name="site" v-model="selectedSite" @change="(e) => updateSiteFilters(e.currentTarget.value)">
						<option value="">All Sites</option>
						<option v-for="option in siteOptions" :value="option.value" :key="option.value">
							{{option.name}}
						</option>
					</select>
					<select name="tags"  @change="(e) => updateTagFilters(e.currentTarget.value)">
						<option value="">All Tags</option>
						<option v-for="option in tagOptions" :value="option.value" :key="option.value">
							{{option.name}}
						</option>
					</select>
					<select name="campaigns" @change="(e) => updateCampaignFilters(e.currentTarget.value)">
						<option value="">All Campaigns</option>
						<option v-for="option in campaignOptions" :value="option.value" :key="option.value">
							{{option.name}}
						</option>
					</select>
				</div>
				<div>
					<button class="button button-primary" @click="downloadExport">
						Export
					</button>
				</div>
			</div>
		</div>
		<table class="wp-list-table widefat fixed striped">
			<thead>
				<tr>
					<th>Name</th>
					<th>Email</th>
					<th>Phone</th>
					<th>Tags</th>
					<th>Date</th>
				</tr>
			</thead>
			<tbody v-if="!isLoading && hasLeads">
				<tr v-for="(lead, index) in mappedLeads" :key="index">
					<td class="name column-name has-row-actions column-primary">
						{{ leadName(lead) }}
						<div class="row-actions">
							<span class="view"><a href="#" @click.prevent="viewLead(index)">View Lead</a></span> |
							<span class="email"><a :href="`mailto:${lead.email}`">Email</a></span> |
							<span class="delete"><a href="#" @click.prevent="deleteLead(lead.id)">Delete</a></span> |
						</div>
					</td>
					<td>
						{{ lead.email }}
					</td>
					<td v-html="lead.phone"></td>
					<td>
						{{ lead.tags }}
					</td>
					<td>
						{{ lead.date }}
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr>
					<td colspan="5">
						<core-loading v-if="isLoading" size="44px"/>
						<span v-else>No Monster Leads found.</span>
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th>Name</th>
					<th>Email</th>
					<th>Phone</th>
					<th>Tags</th>
					<th>Date</th>
				</tr>
			</tfoot>
		</table>
		<div class="tablenav bottom">
			<table-wordpress-pagination
				:count="count"
				:perPage="perPage"
				:setPageCallback="setActivePage"
				:page="page"
			></table-wordpress-pagination>
		</div>
		<monsterleads-modal-show-lead :lead="selectedLead" @before-close="viewLead(null)"/>
	</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('monsterleads')

export default {
	data () {
		return {
			selectedIndex    : null,
			selectedSite     : '',
			selectedCampaign : '',
			selectedTag      : '',
		}
	},
	watch : {
		selectedLead (newValue) {
			if (newValue) {
				this.$nextTick(() => this.$modal.show('show-lead-modal'))
			}
		},
	},
	computed : {
		...mapState([ 'leads', 'count', 'perPage', 'page', 'export' ]),
		...mapGetters({
			campaignOptions   : 'getCampaignFilterOptions',
			siteOptions       : 'getSiteFilterOptions',
			tagOptions        : 'getTagFilterOptions',
			exportQueryString : 'exportQueryString',
		}),
		mappedLeads () {
			return Array.from(this.leads).map((lead) => {
				return {
					id    : lead.id,
					name  : `${lead.first_name} ${lead.last_name || ''}`,
					email : lead.email,
					phone : lead.phone || '<em>Not Provided</em>',
					tags  : lead.tags.join(', '),
					date  : this.$moment(lead.created).format('MM/DD/YYYY HH:mm'),
				}
			})
		},
		hasLeads () {
			return 0 < Array.from(this.leads).length
		},
		selectedLead () {
			return Array.from(this.leads)[this.selectedIndex]
		},
		pageCount () {
			return Math.ceil(this.count / this.perPage)
		},
		isLoading () {
			return this.$store.getters.isLoading('monsterleads')
		},
	},
	methods : {
		viewLead (leadIndex) {
			this.selectedIndex = leadIndex
		},
		setActivePage (pageNumber) {
			if (pageNumber !== this.page) {
				this.changePage(pageNumber)
			}
		},
		downloadExport () {
			this.$api.get('leads/export' + this.exportQueryString)
				.responseType('blob')
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([ response.body ]))
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'MonsterLeads.' + this.export.type)
					document.body.appendChild(link)
					link.click()
				})
		},
		leadName (lead) {
			return lead.name && 'null' !== lead.name.trim() ? lead.name : 'unknown'
		},
		...mapActions(
			[
				'updateCampaignFilters',
				'updateSiteFilters',
				'updateTagFilters',
				'updateStartDate',
				'updateEndDate',
				'updateSearch',
				'deleteLead',
				'changePage',
			]
		),
	},
}
</script>

<style lang="scss" scoped>
	.omapi-monsterleads__actions {
		display: flex;
		justify-content: space-between;
	}
	.omapi-monsterleads__filters {
		display: flex;
	}

	.om-circle-loading {
		margin: 10px auto;
	}
</style>
